import groupBy from "lodash/groupBy";
export const EVENT_COLOR = "#d3d3d3";
export const eventsDisplayName = "Alerts";
export default {
  convert({
    events,
    total_results,
    id,
    type,
    name
  }) {
    return {
      events,
      totalResults: total_results,
      id,
      type,
      name
    };
  },
  toVisualizationData(events, formatTime) {
    const groupedEvents = groupBy(events, (e) => e.timestamp);
    return {
      eventChartData: this.toChartData(groupedEvents, formatTime),
      shapes: this.toShapeData(Object.keys(groupedEvents), formatTime)
    };
  },
  transformGroupedEvents(events) {
    return Object.entries(events).map(([timestamp, eventArray]) => {
      if (!(eventArray instanceof Array)) {
        throw new Error("Unexpected data type");
      }
      if (eventArray.length > 1) {
        return [timestamp, eventArray.length];
      }
      return [timestamp, eventArray[0]];
    });
  },
  toChartData(events, formatTimestamp) {
    const values = this.transformGroupedEvents(events);
    const xValues = values.map((v) => formatTimestamp(v[0]));
    const textValues = values.map((e) => {
      if (typeof e[1] !== "number" && "message" in e[1]) {
        return e[1].message;
      }
      return `${e[1]} alerts occurred.`;
    });
    const yValues = values.map(() => 0);
    return {
      hovertemplate: "%{text}",
      mode: "markers",
      name: eventsDisplayName,
      type: "scatter",
      opacity: 0.5,
      x: xValues,
      y: yValues,
      text: textValues,
      originalName: eventsDisplayName
    };
  },
  toShapeData(timestamps, formatTimestamp) {
    return timestamps.map((timestamp) => {
      const formattedTimestamp = formatTimestamp(timestamp);
      return {
        layer: "below",
        type: "line",
        yref: "paper",
        y0: 0,
        y1: 1,
        x0: formattedTimestamp,
        x1: formattedTimestamp,
        opacity: 0.5
      };
    });
  }
};
